import React, { Suspense, lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import cn from 'classnames'

import { InquiryPage } from 'pages/inquiries'
import { BookingsPage, NewBookingPage, EditBookingPage } from 'pages/bookings'
import {
  LoginPage,
  LogoutPage,
  PasswordResetPage,
  ActivationPage,
} from 'pages/login'
import { DamageReportPage } from 'pages/damage_reports'
import { MaintenencePage } from 'pages/MaintenencePage'

import { Header, Footer } from 'components'
import { useAuthentication } from 'hooks/useAuthentication'
import classes from './App.module.scss'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

const RegisterPage = lazy(() =>
  import('pages/login/RegisterPage').then((module) => ({
    default: module.RegisterPage,
  }))
)

export const App = () => {
  const { maintenenceMode } = useFeatureFlags()
  const { isAuthenticated } = useAuthentication()

  if (maintenenceMode) {
    return <MaintenencePage />
  }

  if (isAuthenticated) {
    return (
      <div className={classes.root}>
        <Header />

        <div className={cn(classes.content, classes.container)}>
          <Switch>
            <Route path="/inquiries" component={InquiryPage} />
            <Route path="/bookings/new" component={NewBookingPage} />
            <Route
              path="/bookings/:bookingId/edit"
              component={EditBookingPage}
            />
            <Route path="/bookings" component={BookingsPage} />
            <Route path="/damage_reports/new" component={DamageReportPage} />
            <Route path="/logout" component={LogoutPage} />
            <Redirect to="/bookings" exact />
          </Switch>
        </div>

        <Footer />
      </div>
    )
  } else {
    return (
      <>
        <Suspense fallback={<div></div>}>
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Route path="/password-reset" component={PasswordResetPage} />
            <Route path="/register" component={RegisterPage} />
            <Route path="/activate" component={ActivationPage} />
            <Redirect to="/login" />
          </Switch>
        </Suspense>
      </>
    )
  }
}
